<div class="container">
    <mat-card *ngIf="!block && !canGenerate">
        <div class="assets-total-summary" *ngIf="paymentOrder">
            <div class="assets-total-icon" aria-hidden="true">
                <mat-icon>account_balance_wallet</mat-icon>
            </div>
            <div class="assets-total-details">
                <span class="assets-total-label">Total bienes asociados</span>
                <span class="assets-total-caption">Valor acumulado de los activos registrados</span>
            </div>
            <strong class="assets-total-value">{{ totalAsset | currency }}</strong>
            <div class="assets-total-available">
                <span>Disponible</span>
                <strong>{{ availableBalance | currency }}</strong>
            </div>
             <button mat-icon-button color="warn" class="assets-total-close" aria-label="Cerrar"
                (click)="onButtonClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <app-list #assets entityName="ActivoFijo" module="MovimientoBienes" group="GS" (loadedData)="getTotalAsset()"
            [dataEntity]="{enableAdd: false, customTitle: 'Bienes Asociados'}"
            [defaultQuery]="[{column:'paymentOrder', value: id }]">
            <div class="actionsTable">
                <button mat-raised-button *ngIf="!block && canAdd && availableBalance > 0"
                    matTooltip="Agregar Bienes" color="primary" (click)="addItem()" [disabled]="!isLoading">
                    <mat-icon>add</mat-icon>
                    Agregar Bienes
                </button>
                <button mat-raised-button
                    *ngIf="canAdd && availableBalance == 0 && !canUploadCertificate && !masterId"
                    matTooltip="Seleccionar Delegado Recibido" color="primary" (click)="selectSupervisor()"
                    [disabled]="!isLoading">
                    <mat-icon>touch_app</mat-icon>
                    Seleccionar Delegado Recibido
                </button>
            </div>
        </app-list>

    </mat-card>
    <mat-card *ngIf="!block && canGenerate">
        <div class="assets-total-summary" *ngIf="paymentOrder">
            <div class="assets-total-icon" aria-hidden="true">
                <mat-icon>account_balance_wallet</mat-icon>
            </div>
            <div class="assets-total-details">
                <span class="assets-total-label">Total bienes asociados</span>
                <span class="assets-total-caption">Valor acumulado de los activos registrados</span>
            </div>
            <strong class="assets-total-value">{{ totalAsset | currency }}</strong>
            <div class="assets-total-available">
                <span>Disponible</span>
                <strong>{{ availableBalance | currency }}</strong>
            </div>
            <button mat-icon-button color="warn" class="assets-total-close" aria-label="Cerrar"
                (click)="onButtonClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-card-title class="form-title">
            Agregar Bienes
        </mat-card-title>
        <mat-card-content>
            <form (keydown.enter)="preventSubmit($any($event))" #form="ngForm" class="col-12" [formGroup]="formAssets"
                (ngSubmit)="save(form)">
                <div class="row align-items-center">

                    <ng-container>
                        <mat-form-field appearance="legacy" class="col-12">
                            <mat-label>Tipo Artículo</mat-label>
                            <input matInput formControlName="typeProduct" [matAutocomplete]="auto" required />
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let value of listTypesProductFiltered" [value]="value">
                                    {{ value.account._id == 511114 ? value.accountUnspsc.description + ' - Consumo' :
                                    value.accountUnspsc.description }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-progress-bar class="over-head" mode="indeterminate"
                                *ngIf="!listTypesProduct"></mat-progress-bar>
                            <mat-error *ngIf="formAssets.get('typeProduct').hasError('required')">
                                Debe seleccionar el tipo de articulo</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container>
                        <mat-form-field appearance="legacy" class="col-12">
                            <textarea matInput formControlName="description" placeholder="Descripción del artículo"
                                required></textarea>
                            <mat-error *ngIf="formAssets.get('description').hasError('required')">
                                La descripción es obligatoria</mat-error>
                            <mat-error *ngIf="formAssets.get('description').hasError('maxlength')">
                                El máximo de caracteres válidos es de 240</mat-error>
                            <mat-hint
                                *ngIf="formAssets.get('description').value && formAssets.get('description').value.length"
                                align="end">{{formAssets.get('description').value ?
                                formAssets.get('description').value.length : 0}}
                                /240</mat-hint>
                        </mat-form-field>
                    </ng-container>

                    <ng-container>
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Valor unitario (Con IVA incluido si aplica)</mat-label>
                            <span [class.disabled]="!formAssets.get('value').enabled"
                                *ngIf="formAssets.get('value').value" class="prefix-inp-form">$</span>
                            <input matInput formControlName="value" appCurrencyDirective
                                (valueChange)="fireCurrency($event)"
                                [class.inp-currency]="formAssets.get('value').value" required>
                            <mat-error *ngIf="formAssets.get('value').hasError('min')">
                                El valor unitario debe ser mayor a $0,00</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('quantity').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Cantidad</mat-label>
                            <input matInput formControlName="quantity" appNumberDirective required>
                            <mat-error *ngIf="formAssets.get('quantity').hasError('min')">
                                La cantidad debe ser mayor a 1</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('withMark').enabled">
                        <div class="align-items-center col-12 col-md-6">
                            <mat-slide-toggle color="primary" formControlName="withMark">Articulo sin
                                marca</mat-slide-toggle>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('mark').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <mat-label>Marca</mat-label>
                            <input matInput formControlName="mark" [matAutocomplete]="autoMark" required />
                            <mat-autocomplete #autoMark="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let value of listMarksFiltered" [value]="value">
                                    {{value.trademarkName}}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-progress-bar class="over-head" mode="indeterminate"
                                *ngIf="!listMarks"></mat-progress-bar>
                            <mat-error *ngIf="formAssets.get('mark').hasError('required')">
                                Debe seleccionar la marca</mat-error>
                            <mat-error *ngIf="formAssets.get('mark')?.hasError('notObject')">
                                Debe seleccionar una marca de la lista</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('withSerial').enabled">
                        <div class="align-items-center col-12 col-md-6">
                            <mat-slide-toggle color="primary" formControlName="withSerial">No tiene número de
                                serial</mat-slide-toggle>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="formAssets.get('serialNumber').enabled">
                        <mat-form-field appearance="legacy" class="col-12 col-md-6">
                            <textarea matInput formControlName="serialNumber" placeholder="Número Serial"
                                required></textarea>
                            <mat-error *ngIf="formAssets.get('serialNumber').hasError('required')">
                                El número de serial es obligatorio</mat-error>
                            <mat-error *ngIf="formAssets.get('serialNumber').hasError('maxlength')">
                                El máximo de caracteres válidos es de 70</mat-error>
                            <mat-hint
                                *ngIf="formAssets.get('serialNumber').value && formAssets.get('serialNumber').value.length"
                                align="end">{{formAssets.get('serialNumber').value ?
                                formAssets.get('serialNumber').value.length : 0}}
                                /70</mat-hint>
                            <mat-error *ngIf="formAssets.get('value').hasError('min')">
                                El mínimo de caracteres válidos es de 6</mat-error>
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="exceedsAvailable">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Seleccione una o más órdenes</mat-label>
                            <mat-select formControlName="orders" multiple [required]>
                                <mat-option *ngFor="let order of listOrders" [value]="order">
                                    {{ order.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formAssets.get('orders').hasError('noMoreOrders')">
                                El valor del bien no requiere que se asignen la totalidad de las órdenes vinculadas,
                                sino solo las que sean suficientes para cubrir su valor.
                            </mat-error>
                            <mat-error *ngIf="formAssets.get('orders').hasError('moreOrders')">
                                El valor del bien requiere la asignación de más órdenes, ya que las actualmente
                                vinculadas no son suficientes para cubrir su valor total.
                            </mat-error>
                        </mat-form-field>
                    </ng-container>
                </div>
            </form>
            <div class="d-flex justify-content-end">
                <ng-container *ngIf="formAssets.get('quantity').enabled && formAssets.get('quantity').value > 1">
                    <mat-card-title> Valor Total: {{ calculateTotal() | currency }}</mat-card-title>
                </ng-container>
            </div>
            <div class="d-flex justify-content-end">
                <button mat-raised-button matTooltip="Cancelar" class="mx-2" (click)="cancel()" [disabled]="!isLoading">
                    Cancelar
                </button>
                <button mat-raised-button matTooltip="Guardar" color="primary" (click)="save(form)"
                    [disabled]="formAssets.invalid">
                    Agregar
                </button>
            </div>
        </mat-card-content>
    </mat-card>
    <app-list *ngIf="canUploadCertificate && assetId" entityName="CertificatesAsset" (reloadData)="reload()"
        module="MovimientoBienes" group="GV" [dataEntity]="{enableAdd: false, customTitle: 'Acta Recibido Satisfacción', exportableDocs:false, group: 'GA', displayGroup: 'GV'}"
        [defaultQuery]="[{column:'assetsRelated_id', value: assetId }, {column:'certificateType', value: ['IP'] }, {column:'dateAnnulment', value: false }]">
    </app-list>
</div>